import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_849n5pbfjm: FaireBrandEntity = {
  token: "b_849n5pbfjm",
  type: "brand",
  name: "42POPS",
  avatarUrl:
    "https://cdn.faire.com/fastly/a52c2d97d28c4b23f7030252643c3d794475118844c5b2bbae3e9175b76450ec.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5784c9c5a1a5dd0d34ee30bf25cd968fd86097fd8de5dd64f095cb9bdc5a3f50.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a52c2d97d28c4b23f7030252643c3d794475118844c5b2bbae3e9175b76450ec.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5784c9c5a1a5dd0d34ee30bf25cd968fd86097fd8de5dd64f095cb9bdc5a3f50.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 6364,
  isTopShop: true,
  isInsider: true,
  description:
    "42, THE ANSWER TO LIFE, THE UNIVERSE, AND EVERYTHING.\nThe Los Angeles-based 42POPS is offering affordable fashion items for missy customers specialized in classic cuts with a dose of comfort.\nLike the number 42, we hope to be an answer to the fashion.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:54.730Z",
    importedBy: "entity-db-cli",
  },
};
